// extracted by mini-css-extract-plugin
module.exports = {"profile":"styles_profile__2xlYF","content":"styles_content__AqZhC"};